import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import Nav from 'infosite/navigation';
import cx from 'classnames';
import { isUndefined } from 'lodash';
import InfositeHelpers from 'infosite/helpers';
import ISI from 'infosite/isi/app';
import IsiActions from 'infosite/isi/actions';
import Spinning from 'grommet/components/icons/Spinning';
import Tracking from 'medscape/tracking';
import Animation from 'medscape/animation';
import { MetaDataActions } from './meta-data-tags/actions';
const ContentCache = {};
export default class Article extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
        content: '',
        hideIsi: false
      };
      this.isFirstPageView = true;
    }
    componentWillMount() {
        const {titleTag, description } = this.props.page["meta-data"];
        MetaDataActions.setTitle(titleTag);
        MetaDataActions.setDescription(description);
        this.getContent(this.props.page);
    }
    shouldComponentUpdate(nextProps, nextState) {
      return this.state.content.length==0 || nextProps.page.path != this.props.page.path || nextState.content != this.state.content || nextState.hideIsi != this.state.hideIsi;
    }
    componentWillUpdate(nextProps, nextState) {
        if(isUndefined(this.props.page) === false &&
            this.state.content.length>0 &&
            nextProps.page!=this.props.page) {
            let $this = $(ReactDOM.findDOMNode(this));
          try {
            InfositeHelpers.unload($this[0]);
            $(document).trigger('article:unload',[this.props.page, $this[0]]);
          } catch(e) {
            console.log("Some Error:",e.message);
          }
        }
        if(nextProps.page.path!=this.props.page.path) {
            const {titleTag, description } = nextProps.page["meta-data"];
            MetaDataActions.setTitle(titleTag);
            MetaDataActions.setDescription(description);
            this.getContent(nextProps.page);
        }
    }
    componentDidMount() {
      this.onRendered();

    }
    componentDidUpdate(prevProps, prevState) {
      if( prevProps.page==this.props.page) {
        this.onRendered();
        this.comment();
      }
    }
    componentWillUnmount() {
        let $this = $(ReactDOM.findDOMNode(this));
        InfositeHelpers.unload($this[0]);
        $(document).trigger('article:unload',[this.props.page, $this[0]]);
    }
    onRendered() {
        let $this = $(ReactDOM.findDOMNode(this));
        if(this.state.content.length>0) {
            let $h1 = $this.find('h1');
            let page = $.extend({},this.props.page,true);
            page["meta-data"].h1 = ($h1.length>0) ? $h1[0].innerText : "";
            InfositeHelpers.updatePage(page);
            InfositeHelpers.load($this[0]);
            $(document).trigger('article:load',[page, $this[0]]);
            const hash = window.location.hash;
            if(Utils.isApp() && Utils.isIOS()) {
              $('#page-content-module a').click(function(e) {
                if(e.target.getAttribute('href').indexOf('#') === 0) {
                  e.preventDefault()
                  window.location = e.target.getAttribute('href');
                }
              });
            }
            if (hash) {
              const element = document.querySelector(hash);
              if (element) {
                element.scrollIntoView();
              }
            }
        }
    }
    comment(){
        if(infosite.config["comment"].icon){
            $('.comments-wrap').css('background-image', config.icon);
        }
        if(infosite.config.comment.isActive && $('.comments-wrap').length > 0){
          $('.comments-wrap').one('click', function() {
            let src = `${window.location.href.split('?')[0]}/articles/comments`;
            $('.infosite-comments iframe').attr('src', src);
          });
        }
        $('.comments-wrap').click(function(event) {
            window.scrollTo(0, 0);
            Tracking.track('comments_open');
            Animation.slideFadeIn(document.getElementById('infosite-comments'),document.getElementsByClassName('infosite-comments')[0]);
        });
        $('.close-btn').click(function(event) {
            Tracking.track('comments_close');
            Animation.slideFadeOut(document.getElementById('infosite-comments'),document.getElementsByClassName('infosite-comments')[0]);
        });
    }
    getContent(page){
        if(ContentCache[page.path]){
            this.setState({
                content: ContentCache[page.path]
            });
            return;
        }
        const doSuccess = (data)=>{
            ContentCache[page.path] = data;
            this.setState({
                content: data
            });
        };
        const doError = (response)=>{
            alert("Ajax Error");
            console.error("Error: PageContent.getContent()",page);
        };
        let baseURL = window.medscape.config.appServer.host+window.medscape.config.appServer.path;
        if(window.medscape.config.env=="localhost"){
            baseURL +="/build/localhost/app";
        }

        let url = `${baseURL}${page.path}`;
        if(window.medscape.config.env=="localhost"){
            url +=".jsp";
        }
        $.ajax({
            type: 'get',
            url: url,
            data: {},
            dataType: 'html',
            cache: false
        }).then(doSuccess,doError);
    }
    getISI(){
        if(!this.props.isi || !this.props.page.showIsiModule){
            return false;
        }
        else{
            let pageSettings = window.medscape.isMobile ? this.props.isi.pageSettings.mobile : this.props.isi.pageSettings.desktop
            let inlineIsi = $.extend({},this.props.isi);
            if(pageSettings.isSticky){
                const containerClass = cx({
                    "isi-container": true,
                    "sticky": pageSettings.isSticky,
                    //"position-top": position=='top',
                    "position-bottom": true,
                    "hidden": this.state.hideIsi
                })
                return (
                    <div>
                        <div id="isi-article-container" className="isi-container">
                            <ISI config={inlineIsi} />
                        </div>
                        <div id="isi-sticky-container" className={containerClass}>
                            <ISI config={this.props.isi} isSticky={true} isInline={false} isExpanded={this.props.isi.isExpanded}/>
                        </div>
                    </div>
                )
            }
            else{
                return(
                    <div id="isi-article-container" className="isi-container">
                        <ISI config={inlineIsi} />
                    </div>
                )
            }

        }
    }
    render(){
        if(this.state.content.length==0){
            const CircleProps = {
                cx: "50",
                cy: "50",
                r: "40",
                "strokeDasharray": "125 126",
                "stroke": "#000",
                "fill": "none",
                "strokeWidth": "20",
                "style":{
                    stroke: "rgb(173, 158, 158)",
                    strokeWidth: "20px",
                    strokeDasharray: "163.363, 87.9646",
                    transfrom: "rotate(126 50 50)"
                }
            }

            const BkProps = {
                className: "bk",
                x: "0",
                y: "0",
                width: "100",
                height: "100",
                fill: "#fff",
                style:{
                    fill: "fill: rgb(255, 255, 255)"
                }
            }
            return(
                <article className="main-content">
                    <div className="article-content">
                        <div className="spinner-container">
                            <div className="spinner">
                            <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className="uil-ring"><rect {...BkProps} ></rect><circle {...CircleProps}></circle></svg>
                            </div>
                        </div>
                    </div>

                </article>
            );
        }

        let content = Utils.getDangerousHtml(this.state.content);
        const isiModule = this.getISI();
        //alert("Update Content: \n"+this.state.content);
        return(
            <article className="main-content">
                <div className="article-content" dangerouslySetInnerHTML={content}></div>
                {isiModule}

            </article>
        );
    }

}

Article.propTypes={
    "page": React.PropTypes.object.isRequired,
    "isi": React.PropTypes.object
}
Article.defaultProps={}



// WEBPACK FOOTER //
// ./src/app/page-content/article.jsx